// extracted by mini-css-extract-plugin
module.exports = {"formWidth":"NewSystemUserForm_formWidth__1ZSYv"};